<template>
    <div class="filter-anchor mt-3">
        <div class="filters-desktop d-none d-xl-block rounded-lg" :class="fixedScroll == true ? 'fixed-scroll bg-white shadow' : 'bg-light'">
            <div class="my-2" :class="fixedScroll == true ? 'container' : 'col-12'">
                <div class="card text-dark border-0" :class="fixedScroll == true ? 'bg-white mb-0 border-0' : 'bg-light mb-3'">
                    <div class="card-body py-0" :class="fixedScroll == true ? 'p-0' : ''">
                        <div class="top-level row">
                            <div class="filter-heading w-auto my-2 flex-fill" v-for="(filter, filter_type) in filters" :key="filter_type">
                                <div class="dropdown">
                                    <button
                                        v-if="Object.keys(filter).length"
                                        :id="filter_type"
                                        class="form-select text-capitalize dropdown-toggle"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        {{ Object.keys(filter_type).length ? filter_type.replace('_', ' ').replace('specialist', 'application') : '' }}
                                    </button>
                                    <div class="dropdown-menu" :aria-labelledby="filter_type">
                                        <label v-for="item, key in filter" :key="key" :for="filter_type + '_' + item" class="dropdown-item flex-fill" :class="this.$parent.selectedFilters[filter_type].includes(item) ? 'active' : ''" @click.stop="">
                                            <input type="checkbox" :name="filter_type + '_' + item" :id="filter_type + '_' + item" class="pe-2" v-model="this.$parent.selectedFilters[filter_type]" :value="item" @change="this.$parent.selectFilter(this.$parent.homeDelivery)" :disabled="isDisabled"/>
                                            {{ item == 'RFT' ? 'Run Flat (RFT)' : item }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <sort-options class="d-none d-sm-block"></sort-options>
                        </div>
                        <div class="applied-filters d-inline-block" v-if="appliedFilterCount > 0">
                            <div class="float-start" v-for="filter, filter_type in this.$parent.selectedFilters" :key="filter_type">
                                <div class="applied-filter-menu" v-if="filter.length > 0">
                                    <label v-for="item, key in filter" :key="key" class="badge py-2 px-3 me-2 rounded-pill applied-filter-item text-capitalize">
                                        <input type="checkbox" class="pe-2" v-model="this.$parent.selectedFilters[filter_type]" :value="item" @change="this.$parent.selectFilter(this.homeDelivery)"/>
                                        <div v-if="filter_type == 'fuel' || filter_type == 'wet' || filter_type == 'speed' || filter_type == 'load_index'"><span> {{ filter_type == 'load_index' ? filter_type.replace('_index', '') : filter_type }} - </span>{{ item.replace('%20', ' ') }} <i class="fa-solid fa-xmark mx-1"></i></div>
                                        <div v-else>{{ item == 'RFT' ? 'Run Flat (RFT)' : item.replace('%20', ' ') }} <i class="fa-solid fa-xmark mx-1"></i></div>
                                    </label>
                                </div>
                            </div>
                            <span class="float-start badge py-2 px-3 rounded-pill bg-success text-white fw-bold" @click="this.$parent.resetFilters()">Clear all <i class="fa-solid fa-xmark mx-1"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-block d-xl-none mb-3 p-2 col-12 g-2 filters-mobile" :class="fixedScroll == true ? 'fixed-scroll bg-white shadow' : 'bg-light'">
            <div class="d-flex row-cols-2">
                <button class="navbar-toggler col me-3 border bg-light" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                    <span>Filter results</span> <span class="text-primary fw-bold" v-if="appliedFilterCount > 0">({{ appliedFilterCount }})</span>
                </button>
                <sort-options class="d-block d-xl-none col"></sort-options>
            </div>
            <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title" id="offcanvasNavbarLabel">Filters</h5>
                    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div class="offcanvas-body pt-0">
                    <form id="filter-form" ref="filterForm">
                        <div class="row">
                            <div class="applied-filters d-inline-block" v-if="appliedFilterCount > 0">
                                <div class="float-start" v-for="filter, filter_type in this.$parent.selectedFilters" :key="filter_type">
                                    <div class="applied-filter-menu" v-if="filter.length > 0">
                                        <label v-for="item, key in filter" :key="key" class="badge py-2 px-3 me-2 rounded-pill applied-filter-item text-capitalize">
                                            <input type="checkbox" class="pe-2" v-model="this.$parent.selectedFilters[filter_type]" :value="item" @change="this.$parent.selectFilter(this.homeDelivery)"/>
                                            <div v-if="filter_type == 'fuel' || filter_type == 'wet' || filter_type == 'speed' || filter_type == 'load_index'"><span> {{ filter_type == 'load_index' ? filter_type.replace('_index', '') : filter_type }} - </span>{{ item.replace('%20', ' ') }} <i class="fa-solid fa-xmark mx-1"></i></div>
                                            <div v-else>{{ item == 'RFT' ? 'Run Flat (RFT)' : item.replace('%20', ' ') }} <i class="fa-solid fa-xmark mx-1"></i></div>
                                        </label>
                                    </div>
                                </div>
                                <span class="float-start badge py-2 px-3 rounded-pill bg-success text-white fw-bold" @click="this.$parent.resetFilters()">Clear all <i class="fa-solid fa-xmark mx-1"></i></span>
                            </div>
                            <div class="accordion" id="mobileFilters">
                                <div class="accordion-item" v-for="(filter, filter_type, index) in filters" :key="filter_type">
                                    <h2 v-if="Object.keys(filter).length" class="accordion-header" :id="filter_type + 'Header'">
                                        <button class="accordion-button text-capitalize collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#' +filter_type + 'Collapse'" aria-expanded="false" :aria-controls="filter_type + 'Collapse'">
                                            {{ filter_type.replace('_', ' ').replace('specialist', 'application') }} ({{ Object.keys(filter).length }})
                                        </button>
                                    </h2>
                                    <div v-if="Object.keys(filter).length" :id="filter_type + 'Collapse'" class="accordion-collapse collapse" :aria-labelledby="filter_type + 'Header'" data-bs-parent="#mobileFilters">
                                        <div class="accordion-body border p-2">
                                            <div class="menu-item show">
                                                <template v-if="filter_type == 'range'">
                                                    <label v-for="item, key in filter" :key="key" :for="filter_type + '_' + item" class="dropdown-item flex-fill" :class="this.$parent.selectedFilters[filter_type].includes(item) ? 'active' : ''" @click.stop="">
                                                        <input type="checkbox" :name="filter_type + '_' + item" :id="filter_type + '_' + item" class="pe-2" v-model="this.$parent.selectedFilters[filter_type]" :value="item" @change="this.$parent.selectFilter(this.$parent.homeDelivery)" :disabled="isDisabled"/>
                                                        {{ item }}
                                                    </label>
                                                </template>
                                                <template v-else>
                                                    <label v-for="item, key in filter" :key="key" :for="filter_type + '_' + item" class="dropdown-item flex-fill" :class="this.$parent.selectedFilters[filter_type].includes(item) ? 'active' : ''" @click.stop="">
                                                        <input type="checkbox" :name="filter_type + '_' + item" :id="filter_type + '_' + item" class="pe-2" v-model="this.$parent.selectedFilters[filter_type]" :value="item" @change="this.$parent.selectFilter(this.$parent.homeDelivery)" :disabled="isDisabled"/>
                                                        {{ item == 'RFT' ? 'Run Flat (RFT)' : item }}
                                                    </label>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['filters', 'isDisabled'],
        components: {
        },
        data() {
            return {
                speedParam: [],
                loadParam: [],
                originalUrl: window.location.protocol + '//' + window.location.host + window.location.pathname,
                fixedScroll: false
            }
        },
        created() {
            //Runs the loadUrlParams function, so any pre-selected filters are applied.
            this.$parent.loadUrlParams();
            
            //Runs the loadFormData function, so the formData is updated with any newly applied filters.
            this.$parent.loadFormData();

            //Adds an event listener for toggling the fixed filters on/off
            window.addEventListener('scroll', this.handleScroll);
        },
        mounted() {

        },
        methods: {
            handleScroll() {
                var filtersOffset = document.querySelector('.filter-anchor').offsetTop;

                if (window.scrollY > filtersOffset) {
                    this.fixedScroll = true;
                } else if (window.scrollY < filtersOffset) {
                    this.fixedScroll = false;
                }
            }
        },
        computed: {
            appliedFilterCount() {
                const filters = Object.values(this.$parent.selectedFilters);
                var count = 0;

                _.forEach(filters, function(filter, key) {
                    _.forEach(filter, function(value, key) { 
                        if(value.length > 0) {
                            count++
                        }
                    });
                });

                return count;
            }
        }
    }
</script>
<style lang="scss" scoped>
    #filter-form {
        label {
            cursor: pointer;
        }
    }
    //Used on desktop and mobile
    .fixed-scroll {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 10;
        box-shadow: 0px 4px 13px rgb(0 0 0 / 7%), 0px 2.59259px 7.61343px rgb(0 0 0 / 5%), 0px 1.54074px 4.14074px rgb(0 0 0 / 4%), 0px 0.8px 2.1125px rgb(0 0 0 / 4%), 0px 0.325926px 1.05926px rgb(0 0 0 / 3%), 0px 0.0740741px 0.511574px rgb(0 0 0 / 2%);
    }
    .filters-desktop, .filters-mobile {
        span, select {
            font-size: 15px;
            cursor: pointer;
        }
        .dropdown-toggle {
            font-size: 15px;
            &::after {
                display: none;
            }
        }
        .dropdown-menu, .applied-filter-menu, .menu-item {
            &.show {
                display: flex;
                width: auto;
                @media screen and (min-width: 576px) {
                    width: 350px;
                    padding: 5px;
                    box-shadow: 0px 4px 13px rgb(0 0 0 / 7%), 0px 2.59259px 7.61343px rgb(0 0 0 / 5%), 0px 1.54074px 4.14074px rgb(0 0 0 / 4%), 0px 0.8px 2.1125px rgb(0 0 0 / 4%), 0px 0.325926px 1.05926px rgb(0 0 0 / 3%), 0px 0.0740741px 0.511574px rgb(0 0 0 / 2%);
                }
                flex-wrap: wrap;
            }
            .dropdown-item, .applied-filter-item {
                width: auto;
                margin: 5px;
                color: #141414;
                background-color: #D3D3D3;
                border-radius: 3px;
                text-align: center;
                padding: 5px 10px;
                cursor: pointer;
                text-transform: inherit;
                input {
                    display: none;
                }
                label {
                    width: 100%;
                    cursor: pointer;
                }
                &.active {
                    background-color: #126AFB;
                    color: #fff;
                }
            }
        }
        .applied-filters {
            .badge {
                &.applied-filter {
                    background-color: #d3d3d3;
                }
                color: #000;
                font-size: 16px;
                font-weight: 300;
                margin: 5px;
                cursor: pointer;
            }
        }
    }
    .filters-mobile {
        .offcanvas-start {
            width: 100%; 
        }
        .navbar-toggler {
            &:focus {
                box-shadow: none;
            }
        }
        .menu-item {
            width: auto !important;
        }
    }
</style>